var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_207_1321)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1587 0.835374C9.66789 0.344548 8.87314 0.344955 8.38269 0.835374L5.49674 3.72135L2.83275 1.05737C2.34193 0.566547 1.54718 0.566953 1.05676 1.05737C0.566345 1.54779 0.565938 2.34253 1.05676 2.83336L3.72075 5.49735L0.834762 8.38334C0.344345 8.87373 0.343939 9.66847 0.834762 10.1593C1.32559 10.6501 2.12033 10.6497 2.61075 10.1593L5.49674 7.27332L8.60471 10.3813C9.09555 10.8721 9.89029 10.8717 10.3807 10.3813C10.8711 9.89088 10.8715 9.09614 10.3807 8.6053L7.27274 5.49735L10.1587 2.61137C10.6491 2.12094 10.6496 1.3262 10.1587 0.835374Z",
    fill: "#303030"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_207_1321"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.6744,
    height: 10.6744,
    fill: "white",
    transform: "translate(0.162109 0.162842)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.dac4d02d93f6f1270522dca9b2fc6c5e.svg";
export { ForwardRef as ReactComponent };